export default {
  data () {
    return {
      historyOptions: [
        { icon: '', color: '' },
        { icon: 'MailIcon', color: 'info' },
        { icon: 'CreditCardIcon', color: 'success' },
        { icon: 'UsersIcon', color: 'success' },
        { icon: 'XIcon', color: 'danger' },
        { icon: 'CheckIcon', color: 'success' }
      ],

      billStatusOptions: [
        {code: -1, status: 'Aucun statut', color: 'danger', type: 1, icon: 'InfoIcon' },
        // ajout pour retro-compatibilité
        {code: 1, status: 'Facture ajoutée', color: 'success', type: 2, icon: 'UploadCloudIcon' },

        {code: 10, status: 'CFC1 à faire', color: 'warning', type: 1, icon: 'ClockIcon' },
        {code: 11, status: 'CFC1 OK', color: 'info', type: 1, icon: 'CheckIcon' },
        {code: 12, status: 'CFC1 pas OK', color: 'danger', type: 2, icon: 'BellIcon' },

        {code: 20, status: 'CFC2 à faire', color: 'warning', type: 1, icon: 'ClockIcon' },
        {code: 21, status: 'CFC2 OK', color: 'info', type: 1, icon: 'CheckIcon' },
        {code: 22, status: 'CFC2 pas OK', color: 'danger', type: 2, icon: 'BellIcon' },

        {code: 30, status: 'En attente de règlement', color: 'warning', type: 1, icon: 'InfoIcon' },

        {code: 40, status: 'CFC3 à faire', color: 'warning', type: 1, icon: 'ClockIcon' },
        {code: 41, status: 'CFC3 OK', color: 'info', type: 2, icon: 'CheckIcon' },

        {code: 51, status: 'CFC4 à faire', color: 'warning', type: 1, icon: 'ClockIcon' },
        {code: 52, status: 'CFC4 OK', color: 'info', type: 2, icon: 'CheckIcon' },
        {code: 53, status: 'CFC4 pas OK', color: 'danger', type: 2, icon: 'BellIcon' },

        {code: 60, status: 'Facture terminée OK', color: 'success', type: 1, icon: 'CheckCircleIcon' },
        {code: 61, status: 'Facture terminée pas OK', color: 'danger', type: 1, icon: 'InfoIcon' },

        {code: 1000, status: 'Facture ajoutée', color: 'success', type: 2, icon: 'UploadCloudIcon' },
        {code: 1001, status: 'Facture supprimée', color: 'danger', type: 2, icon: 'TrashIcon' },
        {code: 1002, status: 'Facture mise à jour', color: 'info', type: 2, icon: 'FileTextIcon' },
        {code: 1003, status: 'Facture à valider', color: 'warning', type: 2, icon: 'CornerDownRightIcon' },
        {code: 1004, status: 'Ne pas traiter', color: 'warning', type: 2, icon: 'AlertCircleIcon' },

        {code: 2000, status: 'Fichier en traitement', color: 'info', type: 2, icon: 'ArchiveIcon' },
        {code: 2005, status: 'Fichier à traiter', color: 'warning', type: 2, icon: 'FlagIcon' },
        {code: 2009, status: 'Fichier non conforme', color: 'danger', type: 1, icon: 'XCircleIcon' },
        {code: 2010, status: 'Fichier refusé', color: 'danger', type: 1, icon: 'frownIcon' },

        {code: 2090, status: 'Coordonnées à valider', color: 'warning', type: 1, icon: 'AlertCircleIcon' },
        {code: 2091, status: 'PDF à scinder', color: 'warning', type: 1, icon: 'InfoIcon'  },

        {code: 3001, status: 'Nouveau message', color: 'warning', type: 1, icon: 'MailIcon'  },

        {code: 9000, status: 'Entrée dans le client', color: 'info', type: 2, icon: 'UserIcon'  },
        {code: 9001, status: 'Entrée dans le destinataire', color: 'info', type: 2, icon: 'UserIcon'  },
        {code: 9002, status: 'Entrée dans la facture', color: 'info', type: 2, icon: 'FileIcon'  },
        {code: 9003, status: 'Modification du destinataire', color: 'info', type: 2, icon: 'UserIcon'  },
        {code: 'R51', status: 'Relance', color: 'danger', type: 1, icon: 'ClockIcon'  }
      ]
    }
  },
  methods: {
    currentBillStatus (code) {
      code = (typeof code === 'string' && code.match(/^\d+$/)) ? parseInt(code) : code
      return ([10, 11, 12, 20, 21, 22, 30, 40, 41, 51, 52, 53, 60, 61, 1000, 1001, 1002, 1003, 1004, 2000, 2005, 2009, 2010, 2090, 2091, 3001, 9000, 9001, 9002, 9003,'R51'].includes(code)) ? this.billStatusOptions.find(option => option.code === code) : this.billStatusOptions[0]
    }
  }
}
